import {
  EnvironmentProviders,
  InjectionToken,
  Signal,
  makeEnvironmentProviders,
  signal,
} from '@angular/core';
import { AccountRef, NavItem, PrimaryAction, SidebarSite } from './nav.models';

/** Tutte le voci dichiarate dalle feature (multi-provider). */
export const NAV_ITEMS = new InjectionToken<readonly NavItem[]>('NAV_ITEMS');

/** Le azioni principali dichiarate dalle feature, una per contesto. */
export const PRIMARY_ACTIONS = new InjectionToken<readonly PrimaryAction[]>('PRIMARY_ACTIONS');

/**
 * I cantieri della sezione "Cantieri" della barra laterale. Vuoto per impostazione predefinita:
 * la feature dei cantieri lo fornisce.
 */
export const SIDEBAR_SITES = new InjectionToken<Signal<readonly SidebarSite[]>>('SIDEBAR_SITES', {
  providedIn: 'root',
  factory: () => signal<readonly SidebarSite[]>([]),
});

/** Gli account che l'utente vede: il percorso mostra l'account solo se sono più di uno. */
export const VISIBLE_ACCOUNTS = new InjectionToken<Signal<readonly AccountRef[]>>(
  'VISIBLE_ACCOUNTS',
  { providedIn: 'root', factory: () => signal<readonly AccountRef[]>([]) },
);

/**
 * Dichiara voci di navigazione. Una feature la chiama in `app.config.ts` (o nei provider del
 * proprio ambiente) e le voci compaiono nella barra laterale, senza modificare `layout/`
 * (FR-023, SC-009).
 */
export function provideNavigation(...items: NavItem[]): EnvironmentProviders {
  return makeEnvironmentProviders(
    items.map((item) => ({ provide: NAV_ITEMS, useValue: item, multi: true })),
  );
}

/** Dichiara l'azione principale di un contesto. */
export function providePrimaryAction(action: PrimaryAction): EnvironmentProviders {
  return makeEnvironmentProviders([{ provide: PRIMARY_ACTIONS, useValue: action, multi: true }]);
}
